import { useMemo } from 'react';
import { KizenTypography } from 'app/typography';
import Loader from 'components/Kizen/Loader';
import styled from '@emotion/styled';
import { units } from './helpers';
import { gutters } from 'app/spacing';
import { collapseNumber } from 'utility/numbers';
import { PERCENTAGE_REPORT_TYPES } from 'components/Wizards/Dashlet/types';
import NoData from './components/NoData';

const Container = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  color: var(--color-font-primary);
  > * {
    // To match designs, needs a slight bump off of center
    margin-top: -${gutters.spacing(1, 2)}pxpx;
  }
`;

const Summary = ({ dashlet, data, isLoading = true, fieldData }) => {
  const fieldCurrencySymbol = fieldData?.moneyOptions?.symbol;

  const hasNoData = !data || !data.data || data.data.length === 0;

  const value = useMemo(() => {
    if (!data) {
      return 0;
    }
    const value = data.data?.find((d) => d.type === 'value');
    return value?.value ?? 0;
  }, [data]);

  const isPercent = useMemo(() => {
    return PERCENTAGE_REPORT_TYPES.includes(dashlet?.config?.reportType);
  }, [dashlet]);

  return (
    <Loader loading={isLoading} paddingTop="8%">
      {hasNoData ? (
        <NoData data-qa-dashlet-id={dashlet?.id} data-qa-no-data />
      ) : (
        <Container>
          <KizenTypography size="hero" data-qa-dashlet-display-field="value">
            {fieldCurrencySymbol}
            {units(collapseNumber(value), dashlet.config)}
            {isPercent ? '%' : ''}
          </KizenTypography>
        </Container>
      )}
    </Loader>
  );
};

export default Summary;
